import React, { useEffect } from 'react';

const StudentsPlacedChart = () => {
  useEffect(() => {
    const bar1 = document.getElementById('bar1');
    const bar2 = document.getElementById('bar2');
    const bar3 = document.getElementById('bar3');

    if (bar1) bar1.style.height = '50%';
    if (bar2) bar2.style.height = '80%';
    if (bar3) bar3.style.height = '60%';

    const donut = document.getElementById('donut');
    let percent = 0;
    const targetPercent = 72;
    const interval = setInterval(() => {
      if (percent <= targetPercent) {
        if (donut) {
          donut.style.background = `conic-gradient(#0ea5e9 0% ${percent}%, #7dd3fc ${percent}% 100%)`;
          donut.textContent = percent + '%';
        }
        percent++;
      } else {
        clearInterval(interval);
      }
    }, 30);

    const path = document.getElementById('growthLine');
    if (path) {
      path.style.transition = 'stroke-dashoffset 2s ease-out';
      path.style.strokeDashoffset = '0';
    }
  }, []);

  return (
    <div className="chart-card">
      <h3>Students Placed Over Years</h3>
      <div className="bar-container">
        {[{ id: 'bar1', value: '794', year: '2023' }, { id: 'bar2', value: '1142', year: '2024' }, { id: 'bar3', value: '812+', year: '2025' }].map((item) => (
          <div className="bar-wrapper" key={item.id}>
            <div className="bar-track">
              <div className="bar" id={item.id}><span className="bar-label">{item.value}</span></div>
            </div>
            <div className="bar-caption">
              <img src="https://cdn-icons-png.flaticon.com/512/3135/3135768.png" alt="cap" />
              <div>{item.year}</div>
            </div>
          </div>
        ))}
      </div>
      {/* Add Donut and Line Graph elements below if needed */}
      {/* <div id="donut" className="donut">72%</div>
      <svg><path id="growthLine" d="..." /></svg> */}

      <style jsx>{`
        .chart-card {
          background: #ffffff;
          border-radius: 20px;
          padding: 2rem;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
          width: 360px;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          text-align: center;
        }
        .chart-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
        }
        .chart-card h3 {
          font-size: 1.5rem;
          margin-bottom: 2rem;
          color: #111827;
        }
        .bar-container {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          height: 240px;
        }
        .bar-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
        }
        .bar-track {
          height: 200px;
          width: 50px;
          background: #e0f2fe;
          border-radius: 10px 10px 0 0;
          position: relative;
          display: flex;
          align-items: flex-end;
        }
        .bar {
          background: linear-gradient(180deg, #06b6d4 0%, #3b82f6 100%);
          width: 100%;
          height: 0;
          border-radius: 10px 10px 0 0;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          transition: height 1s ease;
        }
        .bar-label {
          color: white;
          font-weight: bold;
          padding-top: 6px;
        }
        .bar-caption {
          margin-top: 8px;
          text-align: center;
        }
        .bar-caption img {
          width: 24px;
          height: 24px;
        }
        .bar-caption div {
          font-weight: 600;
          color: #111827;
        }
      `}</style>
    </div>
  );
};

export default StudentsPlacedChart;
